import React, { useEffect, useState } from 'react';
import { Button, DatePicker, Input, Select, notification, Modal, AutoComplete } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import {
    getUserDetailsIfRegistered,
    saveGuestDetails,
} from '../services/apiservice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useHotel } from '../context/HotelContext';
import { isEmpty } from 'lodash';
import { HOTELS_IMAGE_ROOT_URL } from '../constant';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const guestList = [
    { id: 1, label: 'Resident', value: 'Resident' },
    { id: 2, label: 'Walk In', value: 'Walkin' },
];

const visitList = [
    { id: 1, label: 'Regular', value: 'Regular' },
    { id: 2, label: 'Non - Regular', value: 'NonRegular' },
];
const dateFormat = 'YYYY/MM/DD';
const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};
const GuestDetails = () => {
    const navigate = useNavigate();
    let [searchParams] = useSearchParams();
    const outletID = searchParams.get('outletID');
    const [loading, setLoading] = useState(false);

    const [mobileNo, setMobileNo] = useState('');
    const [api, contextHolder] = notification.useNotification();
    const { hotelDetails, isMobileView } = useHotel();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [mealTypeList, setMealTypeList] = useState([]);

    const [selectedStaff, setSelectedStaff] = useState(null);
    const [stafflist, setStaffList] = useState([]);
    const [guestFormDetails, setGuestformDetails] = useState({
        title: 'Mr',
        country_code: '91',
        outlet_id: outletID,
        first_name: '',
        last_name: '',
        email: '',
        dob: '',
        anniversary_date: '',
        mobile: '',
        menu_id: '',
        meal_type: '',
        hotel_id: 170,
        id: 4,
        guest_type: 'Resident',
        visit_type: 'Regular',
        note: '',
        no_of_packs: null,
    });
    const [outletName, setOutletName] = useState('');
    const emailDomains = [
        'gmail.com',
        'yahoo.com',
        'outlook.com',
        'icloud.com',
        'hotmail.com',
    ];

    useEffect(() => {
        // Find outlet name when hotel details or outletID changes
        if (hotelDetails && hotelDetails?.outlets) {
            const matchedOutlet = hotelDetails.outlets.find(
                (outlet) => String(outlet.id) === String(outletID)
            );

            setOutletName(matchedOutlet ? matchedOutlet.name : '');
        }
    }, [hotelDetails, outletID]);

    useEffect(() => {
        const { staff_list = [], meals = [] } = hotelDetails || {};
        if (staff_list && staff_list?.length > 0) {
            const List =
                staff_list?.map((staff) => ({
                    label: staff.name,
                    value: String(staff.id),
                })) || [];
            setStaffList([
                { value: null, label: 'Select Associate', disabled: true },
                ...List,
            ]);
            // setSelectedStaff(List[0].value);
        }
        if (meals?.length > 0) {
            let mealList = meals
                .filter(
                    (item) =>
                        Number(item.outlet_id) === Number(outletID) &&
                        Boolean(item.enabled)
                )
                .map((item) => ({ label: item.name, value: item.id }));

            setMealTypeList(mealList);
        }
    }, [hotelDetails, hotelDetails.meals, hotelDetails.staff_list]);

    useEffect(() => {
        if (mobileNo && mobileNo.length === 10) {
            fetchGuestDetailsIfRegistered();
        }
    }, [mobileNo]);

    const fetchGuestDetailsIfRegistered = async () => {
        try {
            const response = await getUserDetailsIfRegistered(mobileNo);
            if (response.status === 200) {
                const result = response.data || [];
                if (result && !isEmpty(result)) {
                    const newObj = {
                        title: result.title || '',
                        country_code: '91' || '',
                        first_name: result.first_name || '',
                        last_name: result.last_name || '',
                        email: result.email || '',
                        dob: result.dob || '',
                        anniversary_date: result.anniversary_date || '',
                        mobile: result.mobile || '',
                        visit_type: result.visit_type || '',
                        note: result.note || '',
                    };
                    setGuestformDetails({ ...guestFormDetails, ...newObj });
                } else {
                    const blank = {
                        title: 'Mr',
                        country_code: '91',
                        first_name: '',
                        last_name: '',
                        email: '',
                        dob: '',
                        anniversary_date: '',
                        mobile: '',
                        visit_type: 'Regular',
                        note: '',
                    };
                    setGuestformDetails({ ...guestFormDetails, ...blank });
                }
            } else {
                const blank = {
                    title: 'Mr',
                    country_code: '91',
                    first_name: '',
                    last_name: '',
                    email: '',
                    dob: '',
                    anniversary_date: '',
                    mobile: '',
                    visit_type: 'Regular',
                    note: '',
                };
                setGuestformDetails({ ...guestFormDetails, ...blank });
            }
        } catch (error) {}
    };

    const openNotificationWithIcon = (type, title = '', description = '') => {
        api[type]({
            message: title,
            description: description,
        });
    };
    const handleInputChange = (name, value) => {
        setGuestformDetails({
            ...guestFormDetails,
            [name]:
                name === 'no_of_packs' ? parseInt(value, 10) || null : value,
        });
    };
    const handleMobileChange = (value) => {
        const regex = /^[0-9]+$/;
        if (regex.test(value)) {
            setMobileNo(value);
        }
        if (value === '') {
            setMobileNo('');
        }
    };
    const handleNameChange = (name, value) => {
        const regex = /^[a-zA-Z_ ]*$/;
        if (regex.test(value)) {
            handleInputChange(name, value);
        }
    };
    const showConfirmModal = () => {
        if (
            !guestFormDetails.no_of_packs ||
            guestFormDetails.no_of_packs === null ||
            guestFormDetails.no_of_packs < 1
        ) {
            openNotificationWithIcon('error', 'No of Guests is required');
            return;
        }

        if (guestFormDetails.email && !validateEmail(guestFormDetails.email)) {
            openNotificationWithIcon('error', 'Enter valid Email Address!');
            return;
        }
        if (!guestFormDetails.menu_id) {
            openNotificationWithIcon('error', 'Please select the Meal type');
            return;
        }
        if (!selectedStaff) {
            openNotificationWithIcon(
                'error',
                'Please select the associate name'
            );

            return;
        }
        setIsModalVisible(true);
    };

    const getSuggestions = (input) => {
        const atIndex = input.indexOf('@');
        if (atIndex >= 0) {
            const typedDomain = input.slice(atIndex + 1);
            const prefix = input.slice(0, atIndex + 1); // Get the part before '@'
            return emailDomains
                .filter((domain) => domain.startsWith(typedDomain))
                .map((domain) => `${prefix}${domain}`);
        }
        return emailDomains.map((domain) => `${input}@${domain}`);
    };

    const handleModalOk = () => {
        setIsModalVisible(false);
        submitClickHandler();
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
    };

    const submitClickHandler = async () => {
        try {
            setLoading(true);
            const payload = guestFormDetails;
            payload['mobile'] = mobileNo;
            payload['staff_id'] = selectedStaff;
            payload['meal_type'] = guestFormDetails.meal_type;
            const response = await saveGuestDetails(payload);
            if (response.status === 201) {
                openNotificationWithIcon(
                    'success',
                    'Details submitted successfully'
                );
                setTimeout(() => {
                    navigate('/thank-you');
                }, 500);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className='outlet-screen bg-img min-h-dvh flex flex-col justify-start items-center px-4 pb-4'>
            {contextHolder}
            <div className='head-section w-full z-10 flex justify-center items-center flex-row  py-3 relative md:justify-center md:flex-col md:py-5'>
                <div
                    className='back-btn absolute '
                    onClick={() => navigate(-1)}
                ></div>
                {hotelDetails.logo && (
                    <img
                        src={`${HOTELS_IMAGE_ROOT_URL}${hotelDetails.logo}`}
                        alt='logo'
                        className='max-w-20 md:max-w-60'
                        onClick={() => navigate('/', { replace: true })}
                    />
                )}
                <div className='staff-container absolute right-0 '>
                    <Select
                        onChange={(value) => setSelectedStaff(value)}
                        value={selectedStaff}
                        options={stafflist}
                        className='rounded-xl  border-gray-300 text-sm shadow-lg bg-gray-100 w-28 min-h-6 md:w-52 md:min-h-12'
                        size={isMobileView ? 'small' : 'large'}
                    ></Select>
                </div>
            </div>
            <div className='guest-form-heading pt-2 pb-8'>{outletName}</div>

            <div className='guest-form w-full flex flex-col gap-4 p-4 justify-start items-start md:p-6 md:gap-8'>
                <div className='mealtype-container flex flex-col gap-2  w-full md:w-auto'>
                    <p className='form-group-label'>Meal Type</p>
                    <MealTypeComponent
                        list={mealTypeList}
                        selected={guestFormDetails.menu_id}
                        name='menu_id'
                        changeHandler={handleInputChange}
                    />
                </div>
                <div className='mealtype-container flex flex-col gap-2 justify-start items-start w-full md:w-auto'>
                    <p className='form-group-label'>Guest</p>
                    <MealTypeComponent
                        list={guestList}
                        name='guest_type'
                        selected={guestFormDetails.guest_type}
                        changeHandler={handleInputChange}
                    />
                </div>
                <div className='mealtype-container flex flex-col gap-2 justify-start items-start w-full md:w-auto'>
                    <p className='form-group-label'>No of Guests</p>
                    <Input
                        type='num'
                        inputMode='numeric'
                        maxLength={2}
                        max={2}
                        name='no_of_packs'
                        id='no_of_packs'
                        value={guestFormDetails.no_of_packs}
                        onChange={(e) =>
                            handleInputChange(
                                'no_of_packs',
                                Number(e.target.value)
                            )
                        }
                        className='rounded-xl w-24 min-h-12 border-gray-300 px-2 py-1'
                    />
                </div>
                <div className='mealtype-container flex flex-col gap-2 w-full md:w-auto'>
                    <p className='form-group-label'>Mobile No.</p>
                    <div className='mobilewrapper flex items-start justify-start'>
                        <div className='flex flex-row gap-4 justify-between items-center'>
                            <Select
                                name='country_code'
                                id='country_code'
                                onChange={(value) =>
                                    handleInputChange('country_code', value)
                                }
                                value={guestFormDetails.country_code}
                                // options={countryList.map((item) => ({
                                //     label: `${item.emoji}  ${item.dial_code}`,
                                //     value: item.code_value,
                                // }))}
                                options={[{ label: '🇮🇳 +91', value: '91' }]}
                                className='rounded-xl w-24 min-h-12 border-gray-300 '
                                size='large'
                            ></Select>
                            <Input
                                type='tel'
                                size='large'
                                name='mobile'
                                value={mobileNo}
                                onChange={(e) =>
                                    handleMobileChange(e.target.value)
                                }
                                maxLength={10}
                                pattern='[0-9]+'
                                className=' rounded-xl border-gray-300 p-3 flex-1 min-h-12 '
                                autoComplete='off'
                                required
                            />
                        </div>
                    </div>
                </div>
                {mobileNo && mobileNo.length > 9 && (
                    <>
                        <div className='mealtype-container flex flex-col gap-4 w-auto '>
                            <div className='flex gap-2 flex-col md:flex-row'>
                                <div className='flex flex-row gap-2'>
                                    <div
                                        className='input-container flex flex-col gap-2'
                                        style={{ width: '6rem' }}
                                    >
                                        <label>Title</label>
                                        <Select
                                            name='title'
                                            id='title'
                                            onChange={(value) =>
                                                handleInputChange(
                                                    'title',
                                                    value
                                                )
                                            }
                                            value={guestFormDetails.title}
                                            // options={countryList.map((item) => ({
                                            //     label: `${item.emoji}  ${item.dial_code}`,
                                            //     value: item.code_value,
                                            // }))}
                                            options={[
                                                { label: 'Mr.', value: 'Mr' },
                                                { label: 'Ms.', value: 'Ms' },
                                                { label: 'Mrs.', value: 'Mrs' },
                                            ]}
                                            className='rounded-xl w-24 min-h-11 border-gray-300 md:min-h-12'
                                            size='large'
                                        ></Select>
                                    </div>
                                    <div className='input-container flex flex-col gap-2'>
                                        <label>First Name</label>
                                        <Input
                                            onChange={(e) =>
                                                handleNameChange(
                                                    'first_name',
                                                    e.target.value
                                                )
                                            }
                                            maxLength={50}
                                            value={guestFormDetails.first_name}
                                            size='large'
                                            className='min-h-11  rounded-xl text-md md:min-h-12'
                                        />
                                    </div>
                                </div>

                                <div className='input-container flex flex-col gap-2'>
                                    <label>Last Name</label>
                                    <Input
                                        onChange={(e) =>
                                            handleNameChange(
                                                'last_name',
                                                e.target.value
                                            )
                                        }
                                        value={guestFormDetails.last_name}
                                        maxLength={50}
                                        size='large'
                                        className='min-h-11  rounded-xl text-md md:min-h-12'
                                    />
                                </div>
                            </div>
                            <div className='flex w-full gap-4'>
                                <div className='input-container flex flex-col gap-2'>
                                    <label>Email</label>
                                    <AutoComplete
                                        id='email'
                                        value={guestFormDetails.email}
                                        onChange={(value) =>
                                            handleInputChange('email', value)
                                        }
                                        options={
                                            guestFormDetails.email
                                                ? getSuggestions(
                                                      guestFormDetails.email
                                                  ).map((suggestion) => ({
                                                      value: suggestion,
                                                  }))
                                                : []
                                        }
                                        placeholder=''
                                        className='min-h-11 rounded-xl text-md pl-5 md:min-h-12 px-4 py-2 relative'
                                        style={{
                                            minHeight: '48px',
                                            fontSize: '16px',
                                            borderRadius: '12px',
                                            padding: '2px',
                                            zIndex: '0',
                                        }}
                                        size='large'
                                    />
                                </div>
                            </div>
                            <div className='flex flex-col gap-4 w-full md:flex-row'>
                                <div className='input-container flex flex-col gap-2'>
                                    <label>Date of Birth</label>

                                    <DatePicker
                                        onChange={(e, value) =>
                                            handleInputChange('dob', value)
                                        }
                                        inputFontSizeLG
                                        value={
                                            guestFormDetails.dob
                                                ? dayjs(
                                                      guestFormDetails.dob,
                                                      dateFormat
                                                  )
                                                : ''
                                        }
                                        className='min-h-11  rounded-xl w-full text-base md:min-h-12'
                                    />
                                </div>
                                <div className='input-container flex flex-col gap-2'>
                                    <label>Date of Anniversary</label>
                                    <DatePicker
                                        onChange={(e, value) =>
                                            handleInputChange(
                                                'anniversary_date',
                                                value
                                            )
                                        }
                                        value={
                                            guestFormDetails.anniversary_date
                                                ? dayjs(
                                                      guestFormDetails.anniversary_date,
                                                      dateFormat
                                                  )
                                                : ''
                                        }
                                        inputFontSizeLG
                                        className='min-h-11  rounded-xl w-full text-base md:min-h-12'
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <div className='mealtype-container flex flex-col gap-2 justify-start items-start  w-full md:w-auto'>
                            <label>Visits</label>

                            <MealTypeComponent
                                list={visitList}
                                name='visit_type'
                                selected={guestFormDetails.visit_type}
                                changeHandler={handleInputChange}
                            />
                        </div> */}
                        <div className='flex gap-4 w-full'>
                            <div className='input-container w-full md:w-lg flex flex-col gap-2'>
                                <label>Note</label>
                                <TextArea
                                    onChange={(e, value) =>
                                        handleInputChange(
                                            'note',
                                            e.target.value
                                        )
                                    }
                                    value={guestFormDetails.note}
                                    rows={4}
                                    className='min-h-24 rounded-xl w-lg text-base'
                                />
                            </div>
                        </div>
                        <div className='flex w-full justify-center items-center'>
                            <Button
                                size='large'
                                loading={loading}
                                className='submitbtn  rounded-full px-10  min-h-11 bg-blue-400 text-base text-white py-4 md:px-40 md:min-h-16'
                                onClick={showConfirmModal}
                                disabled={
                                    (!mobileNo && !mobileNo < 10) || loading
                                }
                            >
                                Submit
                            </Button>
                        </div>
                    </>
                )}
            </div>
            <Modal
                title='Confirm Submission'
                open={isModalVisible}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
            >
                <p className='mb-4'>
                    Are you sure you want to submit the data?
                </p>
                <div className='bg-yellow-50 border-l-4 border-yellow-400 p-4'>
                    <div className='flex'>
                        <div className='flex-shrink-0'>
                            <ExclamationCircleOutlined className='h-5 w-5 text-yellow-400' />
                        </div>
                        <div className='ml-3'>
                            <p className='text-sm text-yellow-700'>
                                Note: Contacts once created cannot be deleted.
                            </p>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default GuestDetails;

const MealTypeComponent = (props) => {
    const { list = [], changeHandler, selected, name } = props;
    return (
        <>
            <div className='meal-card-row flex flex-row w-full p-1 items-center'>
                {list.map((item) => (
                    <div
                        className={
                            'meal-card flex justify-center items-center ' +
                            (item.value === selected
                                ? 'selected animate__fadeIn'
                                : '')
                        }
                        key={`${Math.random()}-${item.value}`}
                        onClick={() =>
                            changeHandler(name, item.value, item.label)
                        }
                    >
                        {item.label}
                    </div>
                ))}
            </div>
        </>
    );
};
